import classNames from 'classnames';
import { Modal } from 'components/2-molecules/Modal';
import { useState } from 'react';
import { FormRegisterType } from '../BaseInput';
import { HelpButton } from '../HelpButton';
import { RichText } from '../RichText';
import styles from './RadioButton.module.scss';
export interface RadioButtonProps extends Omit<React.ComponentProps<'input'>, 'className' & 'type' & 'id' & 'disabled'> {
	className?: string;
	id: string;
	name: string;
	value?: string;
	label: string;
	helpText?: string;
	helpCtaAriaLabel?: string;
	inline?: boolean;
	formRegister?: FormRegisterType;
	disabled?: boolean;
	hasError?: boolean;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
	className,
	id,
	name,
	value,
	label,
	helpText,
	helpCtaAriaLabel,
	inline = false,
	formRegister,
	disabled,
	hasError,
	...radioButtonInputProps
}: RadioButtonProps) => {
	const [helpTextVisible, setHelpTextVisible] = useState(false);

	return (
		<div
			className={classNames(
				className,
				styles.RadioButton,
				{ [styles.RadioButton___inline]: inline },
				{ [styles.RadioButton___hasError]: hasError },
				{ [styles.RadioButton___disabled]: disabled },
			)}
		>
			<input
				type="radio"
				id={id}
				name={name}
				value={value}
				className={styles.RadioButton_input}
				disabled={disabled}
				{...radioButtonInputProps}
				{...(formRegister && {
					...formRegister.register(formRegister.fieldName, formRegister.options),
				})}
			/>
			<label className={styles.RadioButton_label} htmlFor={id}>
				{label}
				{helpText && (
					<HelpButton
						describedById={id + '-help'}
						helpText={helpText}
						onClick={() => {
							setHelpTextVisible(true);
						}}
						ariaLabel={helpCtaAriaLabel}
						margined
					/>
				)}
			</label>
			{helpText && (
				<>
					<Modal show={helpTextVisible} onClose={() => setHelpTextVisible(false)} aria-hidden={!helpTextVisible}>
						<RichText content={helpText} />
					</Modal>
				</>
			)}
		</div>
	);
};
